<div class="flex w-full align-items-center justify-content-center">
	<i class="pi cm-alert text-4xl mr-3"></i>
	<p>{{ 'DELETE_MESSAGE_WARNING' | translate }}</p>
</div>
<div class="grid mt-3">
	<div class="col-12 flex justify-content-center">
		<button type="button" pButton pRipple (click)="submit()"
			label="{{ 'CONFIRM' | translate }}"
			styleClass="p-dialog p-dialog-footer"
			class="p-button-danger mx-1"
			>
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CANCEL' | translate }}"
			styleClass="p-dialog p-dialog-footer"
			class="p-button-secondary mx-1">
		</button>
	</div>
</div>